<div class="template3">
  <div class="notifications" [ngClass]="notificationConfig.type" *ngIf="!isClose">
    <div class="notifications-container position-relative">
      <div *ngIf="notificationConfig.type !== notificationType.MESSAGE">
        <div class="notify-title" *ngIf="notificationConfig.title" [innerHTML]="notificationConfig.title">
        </div>
        <div class="notify-content" *ngIf="notificationConfig.content" [innerHTML]="notificationConfig.content">
        </div>
        <span class="fa fa-close close-icon" tabindex="0" (keyup.enter)="hideNotification()" (click)="hideNotification()">
        </span>
      </div>
    </div>
  </div>
  <div class="messages" [ngClass]="messageConfig.type" *ngIf="!isSelected">
    <div class="container position-relative">
      <div class="row">
        <div class="col-12 col-md-9 col-lg-9 px-4" [innerHTML]="messageConfig.content">
        </div>
        <span class="col-12 col-md-3 col-lg-2 text-center">
          <button class="btn btn-secondary" tabindex="0" (keyup.enter)="hideMessage()"
            (click)="hideMessage()">Continue</button>
        </span>
      </div>
    </div>
  </div>
</div>
